import styled, {createGlobalStyle} from "styled-components";
import { ToastContainer } from "react-toastify";

export const GlobalStyle = createGlobalStyle`
    html body {
        margin: 0;
        min-width: 1050px;
        height: 100vh;
        line-height: initial;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        /*overflow-x: auto;*/
       /* overflow: hidden;*/
    }
    * {
        scroll-behavior: smooth;
    }
    
    html body,button,input,code{
        font-family: SourceSansPro, Helvetica, Montserrat-Regular, PingFang SC, Microsoft YaHei, SourceHanSerifCN-Medium, robotoregular, Hiragino Sans GB, Heiti SC, WenQuanYi Micro Hei, Helvetica, Arial, monospace, serif;
    }
    body{
        font-size: 16px;
        letter-spacing: 0.02em;
        padding-top: constant(safe-area-inset-top);  
        padding-top: env(safe-area-inset-top);
        padding-bottom: constant(safe-area-inset-bottom);  
        padding-bottom: env(safe-area-inset-bottom);
        --toastify-toast-width: 600px;
    }
    #root{
        /*position: absolute;
        inset: 0;*/
        /*min-width: 1380px;*/
        height: 100%;
        /*margin-right: -17px;*/
        overflow-y: auto;
        @media screen and (max-width: 900px){
            height: auto;
        }
    }
    :root {
        --toastify-toast-background: #fff;
    }
    * {
        margin: 0;
        padding: 0;
        -webkit-tap-highlight-color: transparent;
    }
    
    code {
        font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
        monospace;
    }
    
    button {
        cursor: pointer;
        outline: none;
        border: none;
        font-family: NHaas;
    }
    
    img {
        vertical-align: bottom;
    }
    
    table {
        border-collapse: collapse;
        border-spacing: 0;
        text-align: left;
        th{
            font-weight: normal;
            text-align: left;
        }
        td{
            
        }
    }
    
    body p {
        margin-bottom: 0;
    }
    
    input {
        border: none;
        outline: none;
        &[type="number"]::-webkit-outer-spin-button,
        &[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }
        &[type="number"] {
            -moz-appearance: textfield;
        }
    }
    
    ul {
        list-style: none;
    }
    a{
        text-decoration: none;
    }
    .flex-row {
        display: flex;
        align-items: center;
    }
    .flex-dr {
        display: flex;
        flex-direction: column;
    }
    .flex-sb {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    
    .flex-box {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    .grid-2 {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }
    
    .inputWarn {
        border-color: #E86B4A !important;
    }
    
    /*scrollbar*/
    html ::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: #888FA7;
    }
    
    .scrollbar::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: #888FA7;
    }
    
    .scrollbar::-webkit-scrollbar {
        width: 6px;
        height: 6px;
    }
`;

export const StyledToastContainer = styled(ToastContainer).attrs({
    className: "toast-container",
    toastClassName: "toast-test",
    bodyClassName: "body-test",
    progressClassName: "progress",
})`
    .customer-toast {
        background-color: #252736;
        overflow: visible;
    }
    right: 4em;
`;

export const zIndex = {
    dropDown: 2010,
    loading: 2000,
    modal: 4000,
    editor: 100,
    header: 50
};

export const colors = {
    baseColor: "#fff",
    subtitle: "#A1A8C3",
    Auxiliary: "#888FA7",
    liner: "linear-gradient(90deg, #38FB93 0%, #2EA4FE 100%)",
    border: "#4C4F64",
    inputBg: "#1A1B27",
    placeholder: "#4C4F64"
}

export const AuxiliaryText = styled.span`
    color: ${colors.Auxiliary}
`;

export const LinerText = styled.span`
    background: linear-gradient(90deg, #38FB93 0%, #2EA4FE 100%);
    -webkit-background-clip: text;
    color: transparent;
`;

export const content_width = "1200px";
export const FlexBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;
export const FlexSb = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
`;
export const FlexRow = styled.div`
    display: flex;
    align-items: center;
`;
export const Grid = styled.div<{columns: number, gap?: string}>`
    display: grid;
    grid-template-columns: repeat(${({columns}) => columns}, 1fr);
    column-gap: ${({gap}) => gap || "16px"};
`;

export const LinerButton = styled.button`
    background: ${colors.liner};
    height: 48px;
    border-radius: 8px;
    outline: none;
    text-align: center;
    border: none;
    font-size: 16px;
    font-weight: 500;
    color: #151620;
    padding: 0 12px;
    box-sizing: border-box;
    &:disabled{
        background: #4C4F64;
        color: #888FA7;
        cursor: not-allowed;
        /*opacity: 0.7;*/
    }
`;

export const BorderButton = styled.button`
    height: 48px;
    padding: 0 12px;
    border: 1px solid #fff;
    border-radius: 8px;
    text-align: center;
    background: transparent;
    outline: none;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    box-sizing: border-box;
`;

export const ToastTitle = styled.h5`
    font-size: 26px;
    font-weight: 400;
    color: ${colors.Auxiliary};
    margin: 0 0 8px;
`;
export const ToastContent = styled.div`
    font-size: 16px;
    font-weight: 400;
    color: ${colors.Auxiliary};
`;
